import { addDays, startOfToday } from 'date-fns/esm';
import { EntityState } from '../entity/types';
import { ModalState } from '../settings/types';
import Booking from '../../types/model/Booking';
import { BookingStatus } from '../../enums/BookingStatus';
import { isMobileScreenSize } from '../../utils/isMobileScreenSize';
import { CancellationReason } from '../../enums/CancellationReason';

const isMobileScreen = isMobileScreenSize();

const bookingStatuses = !isMobileScreen
  ? [BookingStatus.Pending, BookingStatus.Open, BookingStatus.Done, BookingStatus.Canceled, BookingStatus.Rejected]
  : [BookingStatus.Pending, BookingStatus.Open, BookingStatus.Done];

export enum BookingModalType {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
  Filters = 'FILTERS',
  LogisticPlan = 'LOGISTIC_PLAN'
}

export interface BookingModalData {
  type: BookingModalType;
  initialValues?: {
    date: string;
    startTime: string;
    endTime: string;
  };
}

export interface BlockedBookingSlotData {
  zoneIds: string;
  projectId: number;
  dateFrom: string;
  dateTo: string;
  timeFrom: string;
  timeTo: string;
}

export interface BookingFilters {
  dateRange: { start: Date; end: Date };
  deliveryZones: number[];
  statuses: BookingStatus[];
  searchText: string;
}

export const defaultBookingFilters: BookingFilters = {
  dateRange: {
    start: startOfToday(),
    end: addDays(startOfToday(), 30)
  },
  deliveryZones: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  statuses: bookingStatuses,
  searchText: ''
};

export interface BlockedBooking {
  id: number;
  deliveryZoneId: number;
  date: string;
  startTime: string;
  endTime: string;
  bookingStatus: number;
  creationIndex: number;
  bookingStatusEnum: string;
  subcontractorContactId: number;
  title: string;
  description: string;
  deliveryZoneName: string;
}

export interface BookingsState extends EntityState<Booking> {
  selectedProjectId: number;
  selectedDate: Date;
  selectedBooking: Booking | null;
  filters: BookingFilters;
  blockedBookings: BlockedBooking[] | null;
  modal: ModalState<BookingModalData>;
  editModal: boolean;
}

export interface BookingCancellationReason {
  reason: CancellationReason;
  reasonText: string;
}

export interface BookingStatusUpdateRequest {
  status: BookingStatus;
  bookingDoneAt?: string;
  cancellationReason?: BookingCancellationReason;
}
